import { render, staticRenderFns } from "./ImportTaskFloat.vue?vue&type=template&id=dddace72&scoped=true"
import script from "./ImportTaskFloat.vue?vue&type=script&lang=js"
export * from "./ImportTaskFloat.vue?vue&type=script&lang=js"
import style0 from "./ImportTaskFloat.vue?vue&type=style&index=0&id=dddace72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddace72",
  null
  
)

export default component.exports